import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/Index.vue'
import Activity from '@/views/activity/Index.vue'
import Draw from '@/views/draw/Index.vue'
import Home from '@/views/home/Home.vue'
import User from '@/views/user/User.vue'
import Login from '@/views/login/login.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: "/home",
    // 子组件：这里是，Main组件下包含有 Home、Activity、User、 Draw 子组件
    children: [
      // 首页的路由信息
      {
        path: 'home',
        name: 'Home',
        component: Home,
      },
      // 活动管理路由的信息
      {
        path: 'activity',
        component: Activity
      },
      // 用户管理路由的信息
      {
        path: 'user',
        name: 'User',
        component: User,
      },
      // 抽奖演示路由的信息
      {
        path: 'draw',
        name: 'Draw',
        component: Draw,
      },
    ] 
  },

  {
    path: "/login",
    name: "Login",
    component: Login
  }
]

const router = new VueRouter({
  routes
})

export default router
